import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DatePipe } from '@angular/common';
import { AppEnvironmentConfig } from 'projects/config/model/environment.config.model';
import { HttpClient } from '@angular/common/http';
import { StartupConfigService } from 'projects/config/startup-config.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { StaticApplicationId, LibSharedCoreModule, getSentryErrorHandlerProvider } from 'projects/lib-shared-core/src/public-api';
import { SVC_APP_SETTINGS, SvcAppSettingsValue, SvcModule } from 'projects/lib-shared-common/src/public-api';
import { LibSharedIconsModule } from 'projects/lib-shared-icons/src/public-api';
import { NgxPermissionsModule } from 'ngx-permissions';
import { APPNAME } from "projects/lib-shared-core/src/lib/Constants/app-injection-token";
import { SvcDataTableCustomSettings } from '@solvace/component/svc-data-table/services/settings/svc-data-table-custom-settings';
import { SvcDataTableSettings } from '@solvace/component/svc-data-table/services/settings/svc-data-table-settings.model';
import { SvcAuthModule } from '@solvace/feature/auth';
import { LibSharedFeatureModule } from '@solvace/feature';
import { WORKSPACE_CIL_INSPECTION_OPENER } from '@solvace/core/features/float-add-button/service/workspace-cil-inspection-opener';
import { CilNewInspectionModalService } from '@solvace/feature/modals/svc-modal-cil-setup/components/cil-inspection-list/services/cil-new-inspection-modal';
import { provideAlertRecordModal } from '@solvace/feature/modals/alert-record-modal';
import { provideZard } from '@solvace/zard/shared/core/provider/providezard';

export function StartupConfigFactory$(
  StartupConfigService: StartupConfigService
) {
  return () => {
    return StartupConfigService.load$();
  };
}

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    NgxPermissionsModule.forRoot(),
    // Core module of your application
    LibSharedCoreModule,
    LibSharedFeatureModule,
    LibSharedIconsModule,
    SvcAuthModule,
  ],
  providers: [
    getSentryErrorHandlerProvider(), // Sentry ErrorHandler for automatic error capture
    DatePipe,
    provideZard(),
    ...provideAlertRecordModal(),
    {
      provide: SvcDataTableCustomSettings,
      useValue: <SvcDataTableSettings> {
        parentScrollElement: { selector: '.mat-mdc-tab-nav-panel' },
      }
    },
    {
      provide: APPNAME,
      useValue: 'myworkspace'
    },
    {
      provide: AppEnvironmentConfig,
      deps: [HttpClient, DatePipe],
      useExisting: StartupConfigService,
    },
    {
      provide: APP_INITIALIZER,
      multi: true,
      deps: [StartupConfigService],
      useFactory: StartupConfigFactory$,
    },
    {
      provide: SVC_APP_SETTINGS,
      useValue: new SvcAppSettingsValue({
        applicationId: StaticApplicationId.myworkspace,
        applicationName: 'MyWorkSpace',
        module: SvcModule.MyWorkspace,
      }),
    },
    { provide: WORKSPACE_CIL_INSPECTION_OPENER, useExisting: CilNewInspectionModalService },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
